module.exports = __webpack_public_path__ + "0bc2416d495cd27c185358a808f90209.png";